import { all, fork } from "redux-saga/effects";
import auth from "./auth";
import jobs from "./jobs";
import interfaceComponents from "./interface";
import task from "./task";

export default function* rootSaga() {
    return yield all([auth, jobs, task, interfaceComponents].map(fork));
}
